import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../api/AxiosInstance";

export const fetchProductDetails = createAsyncThunk(
  "productDetails/fetchProductDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(`product/${id}`);

      if (response.data?.data) {
        return response.data.data;
      }

      return rejectWithValue("Invalid product data received.");
    } catch (error) {
      console.error("Fetch Product Details Error:", error);

      if (error.response) {
        return rejectWithValue(
          `Server error: ${error.response.status} ${error.response.statusText}`
        );
      } else if (error.request) {
        return rejectWithValue("No response from API server.");
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState: {
    product: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearProductDetails: (state) => {
      state.product = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload;
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load product details.";
      });
  },
});

export const { clearProductDetails } = productDetailsSlice.actions;
export default productDetailsSlice.reducer;
